import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus, AiOutlineClose, FiDownload } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { AiOutlineClose as CloseIcon } from 'react-icons/ai';


// Your existing code...


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;
const Asterisk = styled.span`
  color: red;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
    color:#2B3497

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;
// const Input = styled.input`
//   width: 100%;
//   padding: 8px 0;
//   border: none;
//   border-bottom: 1px solid #2B3497;
//   font-family: 'Segoe UI', 'Regular';
//   margin-top:10px;
//   background: transparent;
//   &:focus {
//     outline: none;
//     border-bottom: 2px solid #2B3497;
//   }
// `;


const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 200px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 1px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;
const ModalContainer = styled.div`
position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 29px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 1000;
  width: 80%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  color: #293495;
  font-size: 20px;
  font-weight: bold;
  margin: 0;
`;


const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const InputFieldFull = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const InputFieldHalf = styled.div`
  flex: 0 0 48%;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 5px;
  font-weight: 600;
  color: #000;
`;

const LabelN = styled.label`
  font-weight: 500;
  margin-bottom: 5px;
  color: #000;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', 'Regular';
  margin-top: 10px;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const Checkbox = styled.input`
  transform: scale(1.2);
  margin-top: 5px;
`;

const SubmitButton = styled.button`
  margin-top: 20px;
  background-color: #293495;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: #1f2970;
  }
`;
const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: 'Segoe UI', Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;
const ResetButton = styled.button`
  background-color: red;
margin-top: 20px;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: darkred;
  }
`;





const AddEntityPageMaster = () => {
    const [showInput, setShowInput] = useState(false);
    const [locationName, setLocationName] = useState('');
    const [locations, setLocations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [showPagination, setShowPagination] = useState(false);
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('asc');

    // Sort function


    const rowsPerPage = 7;

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await axios.get('/Entity/GetEntity');

                if (response.data) {
                    // Assuming the API returns an array of locations
                    setLocations(response.data);
                    setShowPagination(true); // Show pagination after submitting at least one row

                } else {
                    setLocations([]); // Ensure locations is always an array
                }
            } catch (error) {
                console.error('Error fetching locations:', error);
                setLocations([]); // Ensure locations is always an array even if the request fails
            }
        };

        fetchLocations();
    }, []);
    const sortData = (data, column, direction) => {
        const sortedData = [...data].sort((a, b) => {
            if (direction === 'asc') {
                return a[column] > b[column] ? 1 : -1;
            } else {
                return a[column] < b[column] ? 1 : -1;
            }
        });
        return sortedData;
    };

    const handleSort = (column) => {
        const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortColumn(column);
        setSortDirection(direction);
        const sortedData = sortData(locations, column, direction);
        setLocations(sortedData);
    };


    const handleAddLocationClick = () => {
        setMode("create");       // ✅ create mode
        setCurrentEntityId(null);
        handleReset();
        setIsModalOpen(true);
    };
    const handleCloseModal = () => setIsModalOpen(false);
    const [showNdaLink, setShowNdaLink] = useState(false);
const [ndaFileUrl, setNdaFileUrl] = useState(""); // for download link


    const handleEdit = (entity) => {
        setMode("edit");         // ✅ edit mode
        setCurrentEntityId(entity.id);

        // Pre-fill form fields
        setEntityName(entity.entityName || "");
        setUploadSafety(entity.uploadSafetyGuidelinesDocuments || false);
        setUploadSafetyDocument(entity.uploadSafetyGuidelinesDocuments || false);
        setUploadNDA(entity.uploadNDADocuments || false);
        setUploadTraining(entity.uploadTrainingVideos || false);
        setUploadPrivacy(entity.showPrivacyPolicy || false);
        setUploadCovid(entity.showCovidFitness || false);
        setTrainingVideosLink(entity.trainingVideosLink || "");
        setSafetyGuidelinesLink(entity.safetyGuidelines?.safetyGuidelinesVideoLink || "");
        setSafetyGuidelinesDocumentLink(entity.safetyGuidelines?.safetyGuidelinesDocumentLink || "");
        setPrivacyText(entity.privacyPolicy || "");
        setCovidText(entity.covidFitness || "");
  setNdaFile(entity.ndaDocumentName || "");  // only file name
  setisActive(entity.isActive)

        setIsModalOpen(true);
    };

    const handleDelete = (id) => {
        confirmAlert({
            title: <span style={{ color: '#dc3545' }}>Warning</span>,
            message: 'Are you sure you want to delete this Entity?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: async () => {
                        try {
                            // Sending the PUT request to mark the location as deleted
                            await axios.post(`Entity/DeleteEntity/${id}`);

                            // Update the local state to remove the deleted location from the UI
                            setLocations((prevData) => prevData.filter(location => location.id !== id));

                            // Show success toast message
                            toast.success('Entity Deleted Successfully');
                        } catch (error) {
                            console.error('Error deleting Entity:', error);
                            // Show error toast message
                            toast.error('Failed to Delete Entity');
                        }
                        const fetchLocations = async () => {
                            try {
                                const response = await axios.get('/Entity/GetEntity');

                                if (response.data) {
                                    // Assuming the API returns an array of locations
                                    setLocations(response.data);
                                    setShowPagination(true); // Show pagination after submitting at least one row

                                } else {
                                    setLocations([]); // Ensure locations is always an array
                                }
                            } catch (error) {
                                console.error('Error fetching Entity:', error);
                                setLocations([]); // Ensure locations is always an array even if the request fails
                            }
                        };

                        fetchLocations();
                    }
                },
                {
                    label: 'No',
                    onClick: () => {
                        // Close dialog without taking any action
                    }
                }
            ]
        });
    };


    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const filteredLocations = locations.filter(location => {
        const name = location.entityName || ''; // Ensure a default value if locationName is null or undefined
        return name.toLowerCase().includes(searchTerm?.toLowerCase() ?? '');
    });


    // Pagination logic
    const itemsPerPage = 7;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredLocations.slice(indexOfFirstItem, indexOfLastItem);




    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const totalPages = Math.ceil(filteredLocations.length / rowsPerPage);

    const handlePageChange = (event) => {
        setCurrentPage(Number(event.target.value));
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const currentRows = filteredLocations.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

        let startPage = Math.max(currentPage - 5, 1);
        let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

        // Adjust startPage if endPage exceeds totalPages
        if (endPage === totalPages) {
            startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <PaginationButton
                    key={i}
                    className={currentPage === i ? 'active' : ''}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </PaginationButton>
            );
        }

        return pageNumbers;
    };
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupData, setPopupData] = useState('');

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);


    const [uploadDocs, setUploadDocs] = useState(false);
    const [uploadNDA, setUploadNDA] = useState(false);
    const [uploadSafetyField, setUploadSafetyField] = useState(false);
    const [uploadPrivacy, setUploadPrivacy] = useState(false);
    const [isActive, setisActive] = useState(false);
    const [uploadCovid, setUploadCovid] = useState(false);
    const [privacyText, setPrivacyText] = useState('');
    const [covidText, setCovidText] = useState('');

    const [uploadTraining, setUploadTraining] = useState(false);
    const [uploadSafety, setUploadSafety] = useState(false);
    const [uploadSafetyDocument, setUploadSafetyDocument] = useState(false);
    const [documentFile, setDocumentFile] = useState('');
    const [ndaFile, setNdaFile] = useState('');
    const [ndaFileObj, setNdaFileObj] = useState(null);
    const [documentFileObj, setDocumentFileObj] = useState(null);
    const [entityName, setEntityName] = useState('');
    const [trainingVideosLink, setTrainingVideosLink] = useState('');
    const [safetyGuidelinesLink, setSafetyGuidelinesLink] = useState('');
    const [safetyGuidelinesDocumentLink, setSafetyGuidelinesDocumentLink] = useState('');


    const handleReset = () => {
        setEntityName('');
        setUploadNDA(false);
        setUploadTraining(false);
        setUploadSafety(false);
        setUploadSafetyField(false);
        setUploadSafetyDocument(false);
        setUploadPrivacy(false);
        setUploadCovid(false);
        setPrivacyText('');
        setCovidText('');
        setSafetyGuidelinesLink('');
        setSafetyGuidelinesDocumentLink('');
        setTrainingVideosLink('')
        setNdaFile('');
        setDocumentFile('');
        setNdaFileObj(null);
        setDocumentFileObj(null);
    };
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve(null);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]); // remove "data:...base64,"
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const [mode, setMode] = useState("create");
    const [currentEntityId, setCurrentEntityId] = useState(null);

    const handleSubmit = async () => {
        if (!entityName.trim()) {
            toast.error("Entity Name is required");
            return;
        }

        if (mode !== "edit") {
        // Create Mode: All checked fields must be provided
        if (uploadNDA && !ndaFileObj) {
            toast.error("Please upload NDA Document");
            return;
        }
        if (uploadTraining && !trainingVideosLink.trim()) {
            toast.error("Please provide Training Video Link");
            return;
        }
        if (uploadSafety && !safetyGuidelinesLink.trim()) {
            toast.error("Please provide Safety Guidelines Link");
            return;
        }
        if (uploadSafetyDocument && !safetyGuidelinesDocumentLink.trim()) {
            toast.error("Please provide Safety Document Link");
            return;
        }
        if (uploadPrivacy && !privacyText.trim()) {
            toast.error("Please enter Privacy Policy details");
            return;
        }
        if (uploadCovid && !covidText.trim()) {
            toast.error("Please enter Covid Fitness details");
            return;
        }
    } else {
        // Edit Mode: Only validate NEW required fields if user changes them
        if (uploadNDA && ndaFileObj === null && ndaFile === "") {
            // meaning user didn't provide a new file and no old file name
            toast.error("Please upload NDA Document");
            return;
        }
        if (uploadTraining && !trainingVideosLink.trim()) {
            toast.error("Please provide Training Video Link");
            return;
        }
        if (uploadSafety && !safetyGuidelinesLink.trim()) {
            toast.error("Please provide Safety Guidelines Link");
            return;
        }
        if (uploadSafetyDocument && !safetyGuidelinesDocumentLink.trim()) {
            toast.error("Please provide Safety Document Link");
            return;
        }
        if (uploadPrivacy && !privacyText.trim()) {
            toast.error("Please enter Privacy Policy details");
            return;
        }
        if (uploadCovid && !covidText.trim()) {
            toast.error("Please enter Covid Fitness details");
            return;
        }
    }

        // If uploadNDA is unchecked, send empty values so server can clear stored NDA
        const ndaBase64 = uploadNDA ? await fileToBase64(ndaFileObj) : "";
        const documentBase64 = uploadSafetyDocument ? await fileToBase64(documentFileObj) : "";

        const requestData = {
            id: mode === "edit" ? currentEntityId : 0,
            entityName,
            uploadSafetyGuidelinesDocuments: uploadSafety,
            uploadNDADocuments: uploadNDA,
            uploadTrainingVideos: uploadTraining,
            ndaDocument: ndaBase64 || "",
            ndaDocumentName: uploadNDA ? (ndaFile || "") : "",   // filename - clear when unchecked
            trainingVideosLink,
            safetyGuidelines: {
                safetyGuidelinesDocumentLink: safetyGuidelinesDocumentLink || "",
                safetyGuidelinesVideoLink: safetyGuidelinesLink || ""
            },
            isActive: true,
            privacyPolicy: privacyText,
            covidFitness: covidText,
            showPrivacyPolicy: uploadPrivacy,
            showCovidFitness: uploadCovid,
            isActive:isActive

        };

        console.log("Final Payload:", requestData);

        try {
            const endpoint = mode === "edit" ? "Entity/EditEntity" : "Entity/CreateEntity";
            const response = await axios.post(endpoint, requestData);
            if (response.data.code !== 0) {
                toast.error(response.data.message)
                return
            }

            toast.success(mode === "edit" ? "Entity updated successfully!" : "Entity created successfully!");

            handleReset();
            setIsModalOpen(false);

            // ✅ Refresh list after save
            fetchLocations();

        } catch (error) {
            console.error("Error saving entity:", error);
        }

        const fetchLocations = async () => {
            try {
                const response = await axios.get('/Entity/GetEntity');

                if (response.data) {
                    // Assuming the API returns an array of locations
                    setLocations(response.data);
                    setShowPagination(true); // Show pagination after submitting at least one row

                } else {
                    setLocations([]); // Ensure locations is always an array
                }
            } catch (error) {
                console.error('Error fetching locations:', error);
                setLocations([]); // Ensure locations is always an array even if the request fails
            }
        };

        fetchLocations();

    };

    const handleDownload = async (ndaDocument) => {
        try {
            const apiUrl = `/document/Documentdownload?token=${encodeURIComponent(ndaDocument)}`;

            const response = await axios.get(apiUrl, {
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // Force the file extension to .doc
            link.setAttribute("download", "NDA_Document.doc");

            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.success("The NDA document has been downloaded successfully.");

        } catch (error) {
            console.error("Error downloading file:", error);
            toast.error("Failed to download the NDA document. Please try again.");
        }
    };
    const handleDownloadSafety = async (safetyGuidelinesDoc) => {
        try {
            const apiUrl = `/document/Documentdownload?token=${encodeURIComponent(safetyGuidelinesDoc)}`;

            const response = await axios.get(apiUrl, {
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // Force the file name to .doc
            link.setAttribute("download", "Safety_Guidelines.doc");

            document.body.appendChild(link);
            link.click();
            link.remove();

            // ✅ Toast with proper grammar
            toast.success("The safety guidelines document has been downloaded successfully.");
        } catch (error) {
            console.error("Error downloading safety guidelines file:", error);
            toast.error("Failed to download the safety guidelines document. Please try again.");
        }
    };





    return (
        <Container>
            <Header>
                <Heading>Add Entity</Heading>
                <SearchBox>
                    <SearchIcon size={20} />
                    <SearchInput
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </SearchBox>
            </Header>
            <Card>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button className="add-location" onClick={handleAddLocationClick}>
                        Add Entity
                    </Button>
                </div>

            </Card>
            <TableContainer>
                <StyledTable>
                    <thead>
                        <tr>
                            <TableHeader colSpan={'9'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Entity Details</span>
                                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                                    </IconWrapper>
                                </div>
                            </TableHeader>

                        </tr>
                    </thead>
                    {isExpanded && (
                        <>
                            <thead>
                                <tr>
                                    <TableHeader onClick={() => handleSort('entityName')}>Entity Name {sortColumn === 'entityName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('uploadNDADocuments')}>Upload Document  {sortColumn === 'uploadNDADocuments' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('locationName')}>NDA Document  {sortColumn === 'locationName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('trainingVideosLink')}>Training Videos  {sortColumn === 'trainingVideosLink' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('safetyGuidelinesVideoLink')}>Safety Guide lines  {sortColumn === 'safetyGuidelinesVideoLink' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('locationName')}>  Safety Guidelines Document Link{sortColumn === 'locationName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('isActive')}>Active {sortColumn === 'isActive' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader>Actions</TableHeader>

                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.entityName}</TableCell>
                                        <TableCell>{row.uploadNDADocuments ? "Yes" : "No"}</TableCell>
                                        <TableCell style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            NDA Document
                                            {row.ndaDocument ? (
                                                <a
                                                    title="Click to download"
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        color: "#007bff",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => handleDownload(row.ndaDocument)}
                                                >
                                                    <FiDownload size={16} />
                                                </a>
                                            ) : null}
                                        </TableCell>
                                        <TableCell style={{ wordBreak: "break-word", whiteSpace: "normal", maxWidth: "250px" }}>
                                            <a href={row.trainingVideosLink} target="_blank" rel="noopener noreferrer">
                                                {row.trainingVideosLink}
                                            </a>
                                        </TableCell>
                                        <TableCell style={{ wordBreak: "break-word", whiteSpace: "normal", maxWidth: "250px" }}>
                                            <a href={row.safetyGuidelines.safetyGuidelinesVideoLink} target="_blank" rel="noopener noreferrer">
                                                {row.safetyGuidelines?.safetyGuidelinesVideoLink}
                                            </a>
                                        </TableCell >
                                        <TableCell style={{ wordBreak: "break-word", whiteSpace: "normal", maxWidth: "250px" }}>
                                            <a href={row.safetyGuidelines.safetyGuidelinesDocumentLink} target="_blank" rel="noopener noreferrer">
                                                {row.safetyGuidelines?.safetyGuidelinesDocumentLink}
                                            </a>
                                        </TableCell>
                                        <TableCell>{row.isActive ? "Yes" : "No"}</TableCell>
                                        <TableCell>
                                            <IconWrapper onClick={() => handleEdit(row)}>
                                                <FiEdit />
                                            </IconWrapper>
                                            <IconWrapper onClick={() => handleDelete(row.id)}>
                                                <FiTrash2 />
                                            </IconWrapper>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </tbody>
                        </>
                    )}
                </StyledTable>
                {isExpanded && (
                    <>
                        <PaginationContainer>
                            <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                                Previous
                            </PaginationButton>

                            <DropdownSelect value={currentPage} onChange={handlePageChange}>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        Page {i + 1}
                                    </option>
                                ))}
                            </DropdownSelect>

                            <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                                Next
                            </PaginationButton>
                        </PaginationContainer>
                    </>
                )}
                {isModalOpen && (
                    <ModalContainer>
                        <ModalHeader>
                            <ModalTitle> {mode === "edit" ? "Edit Entity" : "Add Entity"}</ModalTitle>
                            <CloseIcon size={24} onClick={handleCloseModal} />
                        </ModalHeader>

                        <InputGroup>
                            <InputFieldFull>
                                <Label>Entity Name<Asterisk> *</Asterisk> </Label>
                                <Input
                                    type="text"
                                    placeholder="Enter Entity Name"
                                    required
                                    value={entityName}
                                    onChange={(e) => setEntityName(e.target.value)}
                                />
                            </InputFieldFull>

                            <FlexRow>
                                <InputFieldHalf>
                                    <LabelN>Upload NDA Documents </LabelN>
                                    <Checkbox type="checkbox" checked={uploadNDA} onChange={(e) => setUploadNDA(e.target.checked)} />
                                </InputFieldHalf>
                                {uploadNDA && (
                                    <InputFieldHalf>
                                        <Label>NDA Documents <Asterisk> *</Asterisk> </Label>
                                        <FileUploadContainer>
                                            <CustomFileButton onClick={() => document.getElementById('ndaFileInput').click()}>
                                                Choose File
                                            </CustomFileButton>
                                            <FileNameInput type="text" value={ndaFile} placeholder="No file chosen" readOnly />
                                            <HiddenFileInput
                                                id="ndaFileInput"
                                                type="file"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setNdaFile(file?.name || '');
                                                    setNdaFileObj(file || null);
                                                }}
                                            />
                                        </FileUploadContainer>
                                    </InputFieldHalf>
                                )}
                            </FlexRow>

                            <FlexRow>
                                <InputFieldHalf>
                                    <LabelN>Training Videos </LabelN>
                                    <Checkbox type="checkbox" checked={uploadTraining} onChange={(e) => setUploadTraining(e.target.checked)} />
                                </InputFieldHalf>
                                {uploadTraining && (
                                    <InputFieldHalf>
                                        <Label>Training Videos<Asterisk> *</Asterisk> </Label>
                                        <Input
                                            type="text"
                                            placeholder="Enter Link for Training Videos"
                                            value={trainingVideosLink}
                                            onChange={(e) => setTrainingVideosLink(e.target.value)}
                                        />
                                    </InputFieldHalf>
                                )}
                            </FlexRow>

                            <FlexRow>
                                <InputFieldHalf>
                                    <LabelN>Safety Guidelines </LabelN>
                                    <Checkbox type="checkbox" checked={uploadSafety} onChange={(e) => setUploadSafety(e.target.checked)} />
                                </InputFieldHalf>
                                {uploadSafety && (
                                    <InputFieldHalf>
                                        <Label>Safety Guidelines<Asterisk> *</Asterisk> </Label>
                                        <Input type="text" value={safetyGuidelinesLink}
                                            onChange={(e) => setSafetyGuidelinesLink(e.target.value)} placeholder="Enter Link for Safety Guidelines" />
                                    </InputFieldHalf>
                                )}

                            </FlexRow>
                            <FlexRow>
                                <InputFieldHalf>
                                    <LabelN> Safety Document Link</LabelN>
                                    <Checkbox type="checkbox" checked={uploadSafetyDocument} onChange={(e) => setUploadSafetyDocument(e.target.checked)} />
                                </InputFieldHalf>
                                {uploadSafetyDocument && (
                                    <InputFieldHalf>
                                        <Label>Safety Document Link <Asterisk> *</Asterisk> </Label>
                                        <Input type="text" value={safetyGuidelinesDocumentLink}
                                            onChange={(e) => setSafetyGuidelinesDocumentLink(e.target.value)} placeholder="Enter Link for Safety Guidelines Document link" />
                                    </InputFieldHalf>
                                    // <InputFieldHalf>
                                    //     <Label> Safety Documents</Label>
                                    //     <FileUploadContainer>
                                    //         <CustomFileButton onClick={() => document.getElementById('documentFileInput').click()}>
                                    //             Choose File
                                    //         </CustomFileButton>
                                    //         <FileNameInput type="text" value={documentFile} placeholder="No file chosen" readOnly />
                                    //         <HiddenFileInput
                                    //             id="documentFileInput"
                                    //             type="file"
                                    //             onChange={(e) => {
                                    //                 const file = e.target.files[0];
                                    //                 setDocumentFile(file?.name || '');
                                    //                 setDocumentFileObj(file || null);
                                    //             }} />
                                    //     </FileUploadContainer>
                                    // </InputFieldHalf>
                                )}
                            </FlexRow>
                            <FlexRow>
                                <InputFieldHalf>
                                    <LabelN> Privacy Policy </LabelN>
                                    <Checkbox
                                        type="checkbox"
                                        checked={uploadPrivacy}
                                        onChange={(e) => setUploadPrivacy(e.target.checked)}
                                    />
                                </InputFieldHalf>
                                {uploadPrivacy && (
                                    <InputFieldHalf>
                                        <Label>Privacy Details<Asterisk> *</Asterisk> </Label>
                                        <textarea
                                            style={{
                                                width: '100%',
                                                fontSize: '12px',
                                                padding: '5px 0',
                                                border: 'none',
                                                borderBottom: '1px solid #ccc',
                                                outline: 'none',
                                                resize: 'none',
                                                fontFamily: 'Segoe UI',
                                                backgroundColor: 'transparent'
                                            }} placeholder="Enter privacy details here..."
                                            value={privacyText}
                                            onChange={(e) => setPrivacyText(e.target.value)}
                                        />
                                    </InputFieldHalf>
                                )}
                            </FlexRow>

                            {/* Covid Fitness Checkbox + Textarea */}
                            <FlexRow>
                                <InputFieldHalf>
                                    <LabelN>Covid Fitness </LabelN>
                                    <Checkbox
                                        type="checkbox"
                                        checked={uploadCovid}
                                        onChange={(e) => setUploadCovid(e.target.checked)}
                                    />
                                </InputFieldHalf>
                                {uploadCovid && (
                                    <InputFieldHalf>
                                        <Label>Covid Fitness Details <Asterisk> *</Asterisk> </Label>
                                        <textarea
                                            style={{
                                                width: '100%',
                                                fontSize: '12px',
                                                padding: '5px 0',
                                                border: 'none',
                                                borderBottom: '1px solid #ccc',
                                                outline: 'none',
                                                resize: 'none',
                                                fontFamily: 'Segoe UI',
                                                backgroundColor: 'transparent'
                                            }} placeholder="Enter Covid fitness details here..."
                                            value={covidText}
                                            onChange={(e) => setCovidText(e.target.value)}
                                        />
                                    </InputFieldHalf>
                                )}
                            </FlexRow>
                            <FlexRow>
                                <InputFieldHalf>
                                    <LabelN> Active </LabelN>
                                    <Checkbox
                                        type="checkbox"
                                        checked={isActive}
                                        onChange={(e) => setisActive(e.target.checked)}
                                    />
                                </InputFieldHalf>
                            </FlexRow>
                        </InputGroup>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <ResetButton onClick={handleReset}>Reset</ResetButton>
                            <SubmitButton onClick={handleSubmit}>    {mode === "edit" ? "Update" : "Submit"}
                            </SubmitButton>
                        </div>
                    </ModalContainer>
                )}


            </TableContainer>
            <ToastContainer />

        </Container>
    );
};

export default AddEntityPageMaster;
